import Pjax from "pjax"
import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PanelActivated implements ClientPage {

  private static readonly REFRESH_INTERVAL_MS = 5000
  private static readonly RELOADS_BEFORE_SUPPORT = 3
  private static readonly ATTEMPT_PARAM = "attempt"
  private static readonly FIRST_LOAD = 1

  private reloadTimer: number | null = null
  private pjax: Pjax

  getPageId = (): string => "activated-panel"

  execute = (pjax: Pjax): void => {
    this.pjax = pjax

    const panelEl = document.querySelector("[data-activated-panel]")
    if (!panelEl) return

    const loadNumber = this.getLoadNumber()
    this.revealSupportIfStalled(panelEl, loadNumber)
    this.scheduleReload(loadNumber)
  }

  private getLoadNumber = (): number => {
    const params = new URLSearchParams(window.location.search)
    return parseInt(params.get(PanelActivated.ATTEMPT_PARAM) ?? String(PanelActivated.FIRST_LOAD), 10)
  }

  private revealSupportIfStalled = (panelEl: Element, loadNumber: number): void => {
    const reloadsSoFar = loadNumber - PanelActivated.FIRST_LOAD
    if (reloadsSoFar >= PanelActivated.RELOADS_BEFORE_SUPPORT) {
      const supportEl = panelEl.querySelector("[data-activated-support]")
      supportEl?.classList.remove("d-none")
    }
  }

  private scheduleReload = (loadNumber: number): void => {
    this.reloadTimer = window.setTimeout(() => {
      const url = new URL(window.location.href)
      url.searchParams.set(PanelActivated.ATTEMPT_PARAM, String(loadNumber + 1))
      this.pjax.loadUrl(url.pathname + url.search)
    }, PanelActivated.REFRESH_INTERVAL_MS)
  }

  onPageClose = (): void => {
    if (this.reloadTimer !== null) {
      window.clearTimeout(this.reloadTimer)
      this.reloadTimer = null
    }
  }
}
